<div class="modal-header">
    <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"><i class="feather x"></i></button>
    <h4 class="modal-title" id="myModalLabel">New Conversation</h4>
</div>
<div class="modal-body">
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <label for="clientName">Client</label>
                    <!-- If possible use select2 or something like that pls *_* the clients/accountants list below shoud be based on that select -->
                    <select id="clientName" class="form-control" [(ngModel)]="selectedClient" (change)="changedClient()">
                        <option *ngFor="let c of clients" [ngValue]="c">{{c.name}}</option>
                    </select>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label for="conversationName">Conversation name <span class="optional">(optional)</span></label>
                    <input type="text" id="conversationName" [(ngModel)]="conversation_name" class="form-control" placeholder="Conversation name" autofocus>
                </div>
            </div>
        </div>
        <hr>
        <h4>Participants</h4>
        <p>Click on the persons that you like to add/remove to this conversation.</p>
        <div class="row">
            <div class="col-sm-6">
                <label>Clients</label><br>
                <div class="chat-user-selection-item" [ngClass]="{'selected': u.selected}" *ngFor="let u of selectedClient.users" (click)="toggleSelectedUser(u)">
                    <div class="chat-user-selection-item-wrapper">
                        <div class="chat-user-selection-item-avatar">
                            <div class="avatar avatar-32">
                                <div class="avatar-inicitials" initials [name]="u.user.full_name"></div>
                            </div>  
                        </div>
                        <div class="chat-user-selection-item-info">
                            <div class="name">{{u.user.full_name}}</div>
                            <div class="position" *ngIf="u.id === selectedClient.owner.id">Owner <i tooltip="Notifications On" placement="top" class="feather bell"></i></div>
                            <div class="position" *ngIf="u.id !== selectedClient.owner.id">Staff <i tooltip="Notifications On" placement="top" class="feather bell"></i></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <label>Team Members</label><br>
                <div class="chat-user-selection-item" [ngClass]="{'selected': u.selected}" *ngFor="let u of company.accountants" (click)="toggleSelectedMember(u)">
                        <div class="chat-user-selection-item-wrapper">
                            <div class="chat-user-selection-item-avatar">
                                <div class="avatar avatar-32">
                                    <div class="avatar-inicitials" initials [name]="u.user.full_name"></div>
                                </div>  
                            </div>
                            <div class="chat-user-selection-item-info">
                                <div class="name">{{u.user.full_name}}</div>
                                <div class="position">Accountant <i tooltip="Notifications On" placement="top" class="feather bell"></i></div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
        <hr>
        <h4>Email notifications</h4>
        <label class="checkbox-label">
            <input type="checkbox" checked> I want to receive email notifications on this conversation.
        </label>
</div>
<div class="modal-footer">
    <div class="row">
        <div class="col-4 text-left">
            <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">Cancel</button>
        </div>
        <div class="col-8">
            <button type="button" class="btn btn-primary" [disabled]="selectedUsers.length == 0 || selectedMembers.length == 0" (click)="add_conversation()">Create Conversation</button>
        </div>
    </div>
</div>